// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc9b19e5","239":"39811d27","455":"2ac97b27"}[chunkId] + ".chunk.js";
};